import open from "webmodals/open";
import templateUrl from 'emun.cart/price-calculator/price-calculator.htm'
import controller from "emun.cart/price-calculator/price-calculator.controller";

export default ({
  size = "md",
  backdrop = "static",
  placement = "center",
  preventAutoHeight = true,
  cartItem = {},
  product = cartItem.product,
  title = `Price Calculator`
}) =>
  open({
    size,
    backdrop,
    templateUrl,
    placement,
    controller,
    resolve: {
      preventAutoHeight: () => preventAutoHeight,
      title: () => title,
      cartItem: () => cartItem,
      product: () => product
    },
    bindToController: true,
    controllerAs: "$ctrl"
  }).result;

